export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5341.86d3ee3b.jpg";